import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetTreatmentRequestGroups} from '@/features/treatment-requests/services/treatment-requests.http.ts'
import {raise} from '@utilities/helpers.ts'
import {useState} from 'react'
import {TreatmentRequestTherapistDoctor} from '@/features/treatment-requests/types.ts'

export const useTreatmentRequestGroups = ({
    treatmentRequestId,
    options,
    group,
    startDate,
    endDate
}: {
    treatmentRequestId?: string
    options?: Omit<UseQueryOptions<TreatmentRequestTherapistDoctor[]>, 'queryKey' | 'queryFn'>
    group: 'therapist' | 'referring_doctor'
    startDate?: string
    endDate?: string
}) => {
    const [search, setSearch] = useState('')
    const [distance, setDistance] = useState<number | undefined>(undefined)

    const query = useQuery({
        queryKey: [
            QUERY_KEYS.TREATMENT_REQUESTS_GROUPS,
            treatmentRequestId,
            search,
            distance,
            group,
            startDate,
            endDate
        ],
        queryFn: () =>
            httpGetTreatmentRequestGroups({
                urlParams: {treatmentRequestId: treatmentRequestId ?? raise('treatmentRequestId is nullish')},
                params: {
                    group,
                    distance: 100,
                    search: search || undefined,
                    startDate,
                    endDate
                }
            }),
        ...options
    })

    return {
        ...query,
        search,
        setSearch,
        setDistance
    }
}
